import { createSlice } from '@reduxjs/toolkit';

export const categoriesSlice = createSlice({
    name: 'categories',
    initialState: [],
    reducers: {
        categoriesSet: (state, action) => {
            return action.payload;
        }
    }
});

export const { categoriesSet } = categoriesSlice.actions;
export default categoriesSlice.reducer;
